import { Form } from 'antd';
import * as React from 'react';
import { useMemo } from 'react';
import styled from 'styled-components';
import { getAllFormItemErrors } from '../item/getAllFormItemErrors';
import { useField } from './useField';

export interface IFormErrorMessagesProps {
  name: string;
}

export const $FormItemErrorMessages = styled(Form.Item)`
  .ant-form-item-control {
    min-height: 0;
  }
  /* per i form-item di errore aggiuntivi */
  .ant-form-item-control-input {
    // Nascondiamo l'input
    visibility: hidden;
    display: none;
  }
  .ant-form-item-explain-error {
    /* padding-top: 2px; */
    padding-bottom: 6px;
    margin-top: -4px;
  }
  .ant-form-item-explain {
    display: block;
  }
`;

export function FormErrorMessages(props: IFormErrorMessagesProps) {
  const { name } = props;
  const { error, touched } = useField(name);
  const errors = useMemo(() => getAllFormItemErrors(error), [error]);
  const hasError = !!errors?.length;

  if (!hasError) return null; // pf.t4

  return (
    <$FormItemErrorMessages
      hasFeedback={touched.some(t => t)}
      validateStatus={error.length > 0 ? 'error' : 'success'}
      help={hasError ? errors.map(e => e.error.message).join(', ') : null}
    />
  );
}
